import React from 'react'
import { TextField } from '@mui/material'
import Switch from 'redesign/components/atoms/Switch'
import Select from 'redesign/components/atoms/select'
import AbsenceRequestInfo from 'redesign/components/organisms/absence-request-info/absence-request-info'
import IndividualAbsenceTypeFields from 'redesign/components/organisms/individual-absence-type-fields'
import { AbsenceTypeFieldsContainer, Container } from './styles'
import type { AbsenceAcceptContentProps } from './types'

const AbsenceAcceptContent: React.FC<AbsenceAcceptContentProps> = ({
  task,
  timelineItems,
  diffDaysSwitchProps,
  absenceTypeSelectProps,
  showDiffDaysToggle,
  showSingleTypeField,
  taskCommentFieldProps,
  mirusCommentFieldProps,
  individualAbsenceTypeFieldsProps,
}) => {
  const [absenceInfoItem] = timelineItems

  return (
    <Container>
      <AbsenceRequestInfo task={task} timelineItem={absenceInfoItem} />
      <AbsenceTypeFieldsContainer>
        {showDiffDaysToggle && <Switch {...diffDaysSwitchProps} />}
        {showSingleTypeField ? (
          <Select {...absenceTypeSelectProps} />
        ) : (
          <IndividualAbsenceTypeFields individualAbsenceTypeFieldsProps={individualAbsenceTypeFieldsProps} />
        )}
      </AbsenceTypeFieldsContainer>
      <TextField {...taskCommentFieldProps} />
      <TextField {...mirusCommentFieldProps} />
    </Container>
  )
}

export default AbsenceAcceptContent
